import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

import { RewardForm } from 'src/app/models/app-form';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-type',
  templateUrl: './type.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./type.component.scss']
})
export class TypeComponent implements OnInit, OnDestroy {

  //-- VARIABLES -------------------------------------------------------|

  @ViewChild('registerForm') form;
  public formModel: RewardForm = {};
  public submitted: boolean;
  public firstSubmitted: boolean;
  public loading: boolean;

  ihgPattern = "^[0-9]{1,29}$";

  data: any = {};
  public initLoading: boolean = true;

  private $loadingStatus: Subscription;
  private $appData: Subscription;

  //-- CONSTRUCTOR -----------------------------------------------------|

  constructor(private apiService: ApiService, private appService: AppService) {
    this.$loadingStatus = this.appService.$loadingStatus.subscribe(data => { this.initLoading = data });
    this.$appData = this.apiService.$appData.subscribe(data => { this.applyValues(data); });
  }

  //-- EVENTS ----------------------------------------------------------|

  onSubmit(hasValid) {
    this.firstSubmitted = true;
    this.submitted = true;
    this.loading = true;

    if (this.form.valid && hasValid) {
      this.apiService.register(this.formModel.rewardsNumber);
    } else {
      this.loading = false;
      this.submitted = false;

      if (this.form && this.form.controls.rewardsNumber && this.form.controls.rewardsNumber.invalid) {
        this.form.controls.rewardsNumber.focus();
      }
    }
  }

  //-- UTILITY METHODS -------------------------------------------------|

  applyValues(res: any) {
    this.data = res;
  }
  
  //-- INITIALIZE ------------------------------------------------------|
  
  ngOnInit() {
    setTimeout(() => { this.initLoading = this.appService.getLoadingStatus(); }, 2000);
    const data = this.apiService.getData();
    this.applyValues(data);
    this.appService.addClickEvent();
  }

  //-- DESTORY ---------------------------------------------------------|

  ngOnDestroy() {
    if (this.$loadingStatus) { this.$loadingStatus.unsubscribe(); }
    if (this.$appData) { this.$appData.unsubscribe(); }
  }

  //--------------------------------------------------------------------|







}

